import { BaseUrl } from '@/helpers/BaseUrl';
import adminAxios from '@/plugins/axios';
import { defineStore } from 'pinia';

const userNotificationBaseUrl = BaseUrl.get('userNotification');
const sendNotificationBaseUrl = BaseUrl.get('sendNotification');

export const useNotificationStore = defineStore('userNotification', {
  state: () => {
    return {
      unreadMsgs: 0,
      userNotifications: [],
      sendNotifications: [],
    };
  },
  getters: {
    getUnreadMsgs() {
      return this.unreadMsgs;
    },
    getUserNotifications() {
      return this.userNotifications;
    },
    getSendNotifications() {
      return this.sendNotifications;
    },
  },
  actions: {
    async getUnreadNotification() {
      try {
        const response = await adminAxios.get(`${userNotificationBaseUrl}/unread`);

        this.unreadMsgs = response.data.data;

        return response;
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async getUserNotificationList(params) {
      try {
        const response = await adminAxios.get(`${userNotificationBaseUrl}/list`, { params });

        this.userNotifications.push.apply(this.userNotifications, response.data.data);

        return response;
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async makeRead(id, uuid) {
      try {
        return await adminAxios.put(`${userNotificationBaseUrl}/${id}/status/read?uuid=${uuid}`);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async deleteUserNotification(id, uuid) {
      try {
        return await adminAxios.delete(`${userNotificationBaseUrl}/${id}?uuid=${uuid}`);
      } catch (error) {
        return await Promise.reject(error);
      }
    },

    async getSendNotificationList(params) {
      try {
        const response = await adminAxios.get(`${sendNotificationBaseUrl}/list`, { params });

        this.sendNotifications = response.data.data;

        return response;
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async getSendNotification(id) {
      try {
        return await adminAxios.get(`${sendNotificationBaseUrl}/${id}`);
      } catch (error) {
        return await Promise.reject(error);
      }
    },

    async saveSendNotification(payload, id, uuid) {
      if (id) {
        return await this.editSendNotification(payload, id, uuid);
      } else {
        return await this.createNewSendNotification(payload);
      }
    },
    async createNewSendNotification(payload) {
      try {
        return await adminAxios.post(`${sendNotificationBaseUrl}`, payload);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async editSendNotification(payload, id, uuid) {
      try {
        return await adminAxios.post(`${sendNotificationBaseUrl}/${id}?uuid=${uuid}`, payload);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async deleteSendNotification(id, uuid) {
      try {
        return await adminAxios.delete(`${sendNotificationBaseUrl}/${id}?uuid=${uuid}`);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async reSendNotification(id, uuid) {
      try {
        return await adminAxios.put(`${sendNotificationBaseUrl}/${id}/resend?uuid=${uuid}`);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async sendNotificationNow(id, uuid) {
      try {
        return await adminAxios.put(`${sendNotificationBaseUrl}/${id}/run-now?uuid=${uuid}`);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
  },
});
